module.exports = __webpack_public_path__ + "static/logo_centro_comercial-66431151e307b65619d35a65cbd71ad8.png";